module.exports = __webpack_public_path__ + "static/media/8_5.d2209b37.png";